import { ToastManagerRepository } from "@core/domain/repositories/toast-manager.repository.ts";
import type { Nullable } from "@core/domain/types/nullable.type";
import { RecuperableModelError } from "@iot-platform/core";
import type {
    NotebookMessage,
    NotebookMessageUpdate,
} from "@notebook/domain/models/notebook-message.model";
import type { NotebookMessageRepository } from "@notebook/domain/repositories/notebook-message.repository";
import { notebookTypes } from "@notebook/notebook-types.di";
import { inject, injectable } from "inversify";

@injectable()
export class NotebookMessageUpdateUseCase {
    constructor(
        @inject(notebookTypes.repositories.NotebookMessageRepository)
        private readonly notebookMessageRepository: NotebookMessageRepository,
    ) {}

    async execute(
        notebookMessageId: string,
        notebookId: string,
        notebookMessage: NotebookMessageUpdate,
    ): Promise<Nullable<NotebookMessage>> {
        const editResult = await this.notebookMessageRepository.update(
            notebookMessageId,
            notebookId,
            notebookMessage,
        );

        return editResult.match(
            (notebookMessageEdited) => notebookMessageEdited,
            (error) => {
                if (error instanceof RecuperableModelError) {
                    ToastManagerRepository.warning(error.message);

                    return error.instance;
                }

                ToastManagerRepository.error(error.message);

                return null;
            },
        );
    }
}
